<template>
  <InputSelect
    :name="name"
    :classes="classes"
    :label="label"
    :help="help"
    :isDisabled="isDisabled"
    :isRequired="isRequired"
    :focusOnMount="focusOnMount"
    v-model="value"
    :options="entitySectorsList"
    ref="field"
  >
  <template #link>
      <slot name="link"></slot>
  </template>
  </InputSelect>
</template>

<script>
import { mapGetters } from 'vuex';
import Generator from '@/services/generator/GeneratorService';
import InputMixin from '../InputMixin';

export default {
  name: 'InputEntitySector',
  mixins: [
    InputMixin,
  ],
  computed: {
    ...mapGetters(['entitySectors']),
    entitySectorsList() {
      return this.entitySectors.map((d) => ({
        v: d,
        n: this.$t(`entitySector.${d}`),
      })).sort(Generator.nameSort);
    },
  },
  methods: {
    maybeDeleteValue() {
      this.$refs.field.maybeDeleteValue();
    },
  },
};
</script>
